var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.221 19.0023H5.57006C4.15139 19.0023 3 17.8344 3 16.3953V4.57682C3 4.29179 3.23302 4.05542 3.51401 4.05542C3.795 4.05542 4.02802 4.29179 4.02802 4.57682V16.3953C4.02802 17.2573 4.72023 17.9595 5.57006 17.9595H17.221C17.502 17.9595 17.735 18.1959 17.735 18.4809C17.735 18.7659 17.502 19.0023 17.221 19.0023Z",
    fill: "#292D32",
    stroke: "#292D32",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57053 15.5262C5.45402 15.5262 5.33066 15.4845 5.23471 15.4011C5.02225 15.2134 4.99484 14.8866 5.17988 14.6641L8.32563 10.9379C8.66831 10.5346 9.16175 10.2913 9.68261 10.2705C10.2035 10.2566 10.7175 10.4512 11.0876 10.8266L11.7387 11.4871C11.91 11.6609 12.1293 11.7443 12.376 11.7443C12.6159 11.7373 12.8352 11.6261 12.9928 11.4384L16.1386 7.71212C16.3236 7.49661 16.6458 7.4688 16.8651 7.65651C17.0775 7.84421 17.1049 8.17096 16.9199 8.39342L13.7741 12.1197C13.4315 12.5229 12.938 12.7662 12.4172 12.7871C11.8894 12.801 11.3823 12.6063 11.0122 12.2309L10.368 11.5705C10.1966 11.3967 9.97046 11.3063 9.73059 11.3133C9.49071 11.3202 9.2714 11.4314 9.11377 11.6192L5.96803 15.3454C5.85838 15.4636 5.71445 15.5262 5.57053 15.5262Z",
    fill: "#292D32",
    stroke: "#292D32",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78081 3.00813L16.4303 3.19148C17.8488 3.2138 18.9822 4.39973 18.9602 5.83862L18.7795 17.6557C18.7751 17.9407 18.5385 18.1733 18.2575 18.1689C17.9766 18.1645 17.7472 17.9245 17.7516 17.6395L17.9323 5.82245C17.9455 4.9605 17.2641 4.24753 16.4144 4.23416L4.76486 4.05081C4.4839 4.04638 4.25452 3.80638 4.25888 3.52138C4.26324 3.23638 4.49985 3.0037 4.78081 3.00813Z",
    fill: "#292D32",
    stroke: "#292D32",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluxIcon);
export default __webpack_public_path__ + "static/media/fluxIcon.07a1537938457836bea44984fe4351de.svg";
export { ForwardRef as ReactComponent };